module.exports = __webpack_public_path__ + "img/living-hall-white.b53bf717.webp";